var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.view == 'mensajes')?_c('div',[_c('chats-modal'),_c('b-row',{staticClass:"messages"},[_c('b-col',{staticClass:"col-chats",attrs:{"lg":"3"}},[_c('chats')],1),_c('b-col',{staticClass:"col-messages",attrs:{"lg":"9"}},[_c('conversation')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }